module.exports = __webpack_public_path__ + "img/perm_data_setting.d6c600ec.svg";